var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12L16.2071 11.2929L16.9142 12L16.2071 12.7071L15.5 12ZM10.2071 5.29289L16.2071 11.2929L14.7929 12.7071L8.79289 6.70711L10.2071 5.29289ZM16.2071 12.7071L10.2071 18.7071L8.79289 17.2929L14.7929 11.2929L16.2071 12.7071Z",
    fill: "#7161BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPNext);
export default __webpack_public_path__ + "static/media/pNext.397fea00faa12c41adbbbd2ded94dab5.svg";
export { ForwardRef as ReactComponent };